
import { Vue } from "vue-class-component";

export default class PencilEdit extends Vue {}
